var _excluded = ["label", "isMenuOpen", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from '@chakra-ui/react';
import { Icon } from '../../../foundations/Icon';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Text } from '../../dataDisplay';
import { _useTableContext as useTableContext } from '../_Table/_TableContext';
import { _TableHeaderCell as TableHeaderCell } from '../_TableHeaderCell';
import { _TableHeaderCellDescription as TableHeaderCellDescription } from '../_TableHeaderCellDescription';
import { Box } from '../Box';
import { Grid } from '../Grid';
/**
 * @private This is for internal use only.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private This is for internal use only.
 *
 * Please use `Table._MenuTriggerHeaderCell` from `@melio/penny`.
 *
 * Meant to be used as a trigger for a menu inside a table header cell.
 */
export var _TableMenuTriggerHeaderCell = forwardRef((_ref, ref) => {
  var {
    label,
    isMenuOpen,
    description
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var {
    headerVariant
  } = useTableContext();
  var style = useStyleConfig('TableMenuTriggerHeaderCell', {
    variant: headerVariant
  });
  return /*#__PURE__*/_jsx(TableHeaderCell, _objectSpread(_objectSpread({
    "data-component": "_TableMenuTriggerHeaderCell",
    as: "button"
  }, restProps), {}, {
    ref: ref,
    children: /*#__PURE__*/_jsx(Box, {
      __css: style,
      children: /*#__PURE__*/_jsxs(Grid, {
        templateColumns: "1fr auto",
        columnGap: "m",
        rowGap: "xxs",
        alignItems: "center",
        width: "100%",
        children: [/*#__PURE__*/_jsx(Text, {
          textStyle: "body4Semi",
          color: "inherit",
          shouldSupportEllipsis: true,
          children: label
        }), /*#__PURE__*/_jsx(Icon, {
          type: isMenuOpen ? 'caret-up' : 'caret-down',
          size: "small",
          color: "inherit"
        }), description && /*#__PURE__*/_jsx(TableHeaderCellDescription, {
          text: description
        })]
      })
    })
  }));
});
_TableMenuTriggerHeaderCell.displayName = '_TableMenuTriggerHeaderCell';
//# sourceMappingURL=_TableMenuTriggerHeaderCell.js.map